var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSliderIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 204,
    viewBox: "0 0 204 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 13H10L56 13C77.1148 13 95.1103 26.3553 102 45.0794C108.89 26.3553 126.885 13 148 13L194 13H197V16L197 142C197 169.062 175.062 191 148 191H102L56 191C28.938 191 7 169.062 7 142L7 16L7 13ZM99 62C99 38.2518 79.7482 19 56 19L13 19L13 142C13 165.748 32.2518 185 56 185L99 185L99 62ZM105 185L105 62C105 38.2518 124.252 19 148 19L191 19L191 142C191 165.748 171.748 185 148 185H105Z",
    fill: "#871C6A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderIcon1);
export default __webpack_public_path__ + "static/media/slider_icon1.0a93f0c8f59ee0c8ed1ddd5dea32e3b8.svg";
export { ForwardRef as ReactComponent };